import { API_ROOT } from "../baseUrls";

export function requestToBecomeContributor(mindfileId, authenticityToken) {
  // const formData = new FormData();
  // formData.append("authenticity_token", authenticityToken);
  fetch(
    `${API_ROOT}/mindfiles/request_join/${mindfileId}`,
    {
      method: "POST",
      credentials: "include",
      // body: formData,
      headers: {'X-CSRF-Token': authenticityToken},
    }
  )
    .then(resp => resp.text())
    .catch(error => console.error(error));
}

export function allowContributorRequest(mindfileId, requestId, authenticityToken) {
  const formData = new FormData();
  formData.append("allow_id", requestId);
  // formData.append("authenticity_token", authenticityToken);

  const promise = fetch(`${API_ROOT}/mindfiles/${mindfileId}/contributors`, {
    method: "POST",
    credentials: "include",
    body: formData,
    headers: {'X-CSRF-Token': authenticityToken},
  })
    .then(resp => resp.text())
    .catch(error => {
      console.error(error);
      throw error;
    });

  return promise;
}

export function denyContributorRequest(mindfileId, requestId, authenticityToken) {
  const formData = new FormData();
  formData.append("deny_id", requestId);
  // formData.append("authenticity_token", authenticityToken);

  const promise = fetch(`${API_ROOT}/mindfiles/${mindfileId}/contributors`, {
    method: "POST",
    credentials: "include",
    body: formData,
    headers: {'X-CSRF-Token': authenticityToken},
  })
    .then(resp => resp.text())
    .catch(error => {
      console.error(error);
      throw error;
    });

  return promise;
}
